import React, { useState } from 'react'

import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { Calendar, Clock, Download } from 'react-feather'
import { isEmpty } from 'lodash'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'
import useStyles from './styles'

const MAX_VISIBLE_CATEGORIES = 2

const CertificateCard = ({ certificate }) => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const [isDownloading, setIsDownloading] = useState(false)

  const categories = isEmpty(certificate.categories)
    ? []
    : certificate.categories
  const visibleCategories = categories.slice(0, MAX_VISIBLE_CATEGORIES)
  const hiddenCategories = categories.slice(MAX_VISIBLE_CATEGORIES)

  const completedAt = certificate.completedAt
    ? helpers.formatters.date(certificate.completedAt)
    : '-'

  const handleDownload = async () => {
    setIsDownloading(true)
    try {
      const token = service.trainingPortal.auth.getToken()
      const response = await fetch(certificate.certificateUrl, {
        headers: { Authorization: token },
      })

      if (!response.ok) {
        snackbar.open({
          message: 'Não foi possível gerar o certificado. Tente novamente.',
          variant: 'error',
        })
        return
      }

      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = objectUrl
      link.download = `certificado-${certificate.courseId}.pdf`
      link.click()
      setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
    } catch {
      snackbar.open({
        message: 'Erro ao baixar o certificado. Verifique sua conexão.',
        variant: 'error',
      })
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.meta}>
        {!isEmpty(visibleCategories) && (
          <Box className={classes.categories}>
            {visibleCategories.map((category) => (
              <Typography
                key={category.id}
                component="span"
                className={classes.category}
              >
                {category.name}
              </Typography>
            ))}
            {!isEmpty(hiddenCategories) && (
              <Tooltip
                title={hiddenCategories
                  .map((category) => category.name)
                  .join(', ')}
                placement="top"
              >
                <Typography component="span" className={classes.categoryExtra}>
                  +{hiddenCategories.length}
                </Typography>
              </Tooltip>
            )}
          </Box>
        )}
        <Box className={classes.metaEnd}>
          <Typography component="span" className={classes.lessonCount}>
            {certificate.lessonsCount}{' '}
            {certificate.lessonsCount === 1 ? 'Aula' : 'Aulas'}
          </Typography>
          {certificate.status && (
            <Chip
              size="small"
              label={
                constants.certificates.STATUS_LABEL[certificate.status] ||
                certificate.status
              }
              className={`${classes.statusChip} ${
                classes[
                  constants.certificates.STATUS_CLASS_NAME[certificate.status]
                ] || ''
              }`}
            />
          )}
        </Box>
      </Box>

      <Typography className={classes.title}>{certificate.title}</Typography>

      <Box className={classes.info}>
        <Box className={classes.infoItem}>
          <Calendar size={14} className={classes.infoIcon} />
          <Typography className={classes.infoText}>{completedAt}</Typography>
        </Box>
        {certificate.totalDuration && (
          <Box className={classes.infoItem}>
            <Clock size={14} className={classes.infoIcon} />
            <Typography className={classes.infoText}>
              {certificate.totalDuration}
            </Typography>
          </Box>
        )}
      </Box>

      <Button
        variant="contained"
        color="secondary"
        fullWidth
        startIcon={
          isDownloading ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <Download size={16} />
          )
        }
        onClick={handleDownload}
        disabled={isDownloading}
        className={classes.downloadButton}
      >
        {isDownloading ? 'Baixando...' : 'Baixar Certificado'}
      </Button>
    </Box>
  )
}

export default CertificateCard
